import { Block } from "@components/block";
import { Breadcrumbs } from "@components/breadcrumbs";
import { DeviceDetailInfo } from "@components/device-info";
import { FlexLoader } from "@components/loader";
import { Config, Table } from "@components/table";
import { useDevices } from "@features/device";
import { Message } from "@features/device/api";
import { formatDate, formatTime } from "@helpers/date";
import { useEffect, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import styles from "./device.module.scss";

const messagesConfig: Config<Message> = [
  {
    source: "sender",
    label: "Номер телефона",
  },
  {
    source: "date",
    label: "Время",
    renderComponent: (dateTime) => formatTime(new Date(dateTime)),
  },
  {
    source: "date",
    label: "Дата",
    renderComponent: (dateTime) => formatDate(new Date(dateTime)),
  },
  {
    source: "message",
    label: "Сообщение",
    renderComponent: (message) => (
      <span className={styles.customCell}>{message}</span>
    ),
  },
];

export const DevicePage = () => {
  const location = useLocation();

  const isEdit = location.pathname.endsWith("/edit");

  const { deviceId } = useParams();

  const { state, getDeviceMessages } = useDevices();

  useEffect(() => {
    if (deviceId) {
      getDeviceMessages(deviceId);
    }
  }, [deviceId, getDeviceMessages]);

  const device = useMemo(
    () => (deviceId ? state.devices[deviceId] : null),
    [deviceId, state.devices]
  );

  if (!device || !deviceId) {
    return <FlexLoader />;
  }

  return (
    <div className={styles.container}>
      <Breadcrumbs
        items={[
          "Устройства",
          device.name,
          ...(isEdit ? ["Редактирование устройства"] : []),
        ]}
      />
      <DeviceDetailInfo device={device} className={styles.device} />
      <Block>
        <Table
          title="Сообщения на устройстве"
          placeholder="Поиск по сообщениям"
          config={messagesConfig}
          loading={state.loadingMessages}
          data={device?.messages}
        />
      </Block>
    </div>
  );
};
